<template>
  <v-dialog v-model="show" persistent width="400px" data-testid="transfer-dialog">
    <v-card data-testid="transfer-card">
      <v-card-title data-testid="transfer-title">
        <span v-if="msg" class="subheading" v-html="$t('vmail.xfer.title')" data-testid="single-transfer-title" />
        <span v-if="bulk" class="subheading" v-html="$t('vmail.xfer.bulkTitle', { count: bulk.length })" data-testid="bulk-transfer-title" />
      </v-card-title>
      <v-divider data-testid="title-divider"></v-divider>
      <v-card-text class="pt-4" data-testid="transfer-content">
        <msg-info v-if="msg" :msg="msg" data-testid="msg-info" />
        <span v-if="bulk" v-html="$t('vmail.xfer.bulkIntro', { count: bulk.length })" data-testid="bulk-transfer-description" />
        <v-combobox class="mt-6"
          v-model="dest"
          :label="$t('vmail.xfer.destinationLabel')"
          :placeholder="$t('vmail.xfer.destinationPlaceholder')"
          :items="list"
          dense
          clearable
          hide-no-data
          data-testid="destination-combobox">
          <template v-slot:item="{ item }">
            <div data-testid="destination-item" class="d-flex">
              <v-list-item-avatar data-testid="destination-avatar">
                <v-img v-if="item.hasImage" :src="item.imageUrl" :alt="item.name" data-testid="user-avatar"></v-img>
                <v-img v-else src="/default_picture_profile.png" :alt="item.name" data-testid="default-avatar"></v-img>
              </v-list-item-avatar>
              <v-list-item-content data-testid="destination-content">
                <v-list-item-title v-html="item.name" data-testid="destination-name" />
                <v-list-item-subtitle data-testid="destination-subtitle">
                  {{ item.label }}: {{ item.phoneNumber | formatPhoneNum(countryCode) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </div>
          </template>
        </v-combobox>
      </v-card-text>
      <v-divider data-testid="content-divider"></v-divider>
      <v-card-actions data-testid="transfer-actions">
        <v-spacer data-testid="actions-spacer"></v-spacer>
        <v-btn text v-html="$t('vmail.xfer.btnCancel')" @click="$emit('cancel')" data-testid="cancel-button" />
        <v-btn text v-html="$t('vmail.xfer.btnXfer')" @click="xfer" :disabled="!dest" color="primary" data-testid="transfer-button" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import MsgInfo from './msg_info'

export default {
  name: 'voicemail-msg-xfer',
  components: { MsgInfo },
  data () {
    return {
      dest: null
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      required: false
    },
    bulk: {
      type: Array,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      countryCode: 'countryCode',
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers',
      voicemailFilter: 'voicemails/filter'
    }),
    list: function () {
      return this.phoneNumbers
        .filter(num => num.label.toLowerCase() === 'extension')
        .map(num => ({
          text: `${num.name} <${num.phoneNumber}>`,
          phoneNumber: num.phoneNumber,
          name: num.name,
          label: num.label,
          hasImage: num.hasImage,
          imageUrl: num.imageUrl
        }))
        .sort((a, b) => a.name.localeCompare(b.name))
    },
    currentFolder () {
      return (this.voicemailFilter?.folder === 'all' ? null : this.voicemailFilter?.folder) || null
    }
  },
  methods: {
    xfer () {
      this.$emit('xfer-dest', this.dest.phoneNumber)
      this.dest = null
      if (this.$route?.params?.folder === 'detail') {
        this.$router.push({ name: 'voicemails', params: { folder: this.currentFolder } })
      }
    }
  }
}
</script>

<style scoped>
</style>
